import __cloneDeep from 'lodash/cloneDeep';

// Modules getters
export const getContent = state => __cloneDeep(state.content);
export const getModule = state => name => __cloneDeep(state.content[name]);
export const getModuleMeta = state => name => state.content[name].meta;
export const getModuleComponents = state => name => state.content[name].components;

export default {
  getContent,
  getModule,
  getModuleMeta,
  getModuleComponents
};



// WEBPACK FOOTER //
// ./src/store/modules/modules/getters.js